:host {
  display: block;
}

.breadcrumbs {
  box-sizing: border-box;
  padding: 14px 16px 10px;
}

.breadcrumbs--hide-mobile {
  display: none;
}

@media screen and (min-width: 980px) {
  .breadcrumbs {
    display: block;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    padding: 8px 10px;
    background-color: transparent;
  }
}

.highlight-naming .accent {
  font-weight: bold;
}